export default __webpack_public_path__ + "static/media/NIEM-NO-Horiz-Logo-WEB-FINAL.ea1859a9.png";